import { DataExtractor } from "@impero-com/common/utils/dataView";

/**
 * Erases an extractor's value/filter-value type parameters so extractors with
 * differing value types can be collected into a single homogeneous array.
 */
export function downgradeExtractorType<ITEM, VAL, FV>(
    extractor: DataExtractor<ITEM, VAL, FV>
): DataExtractor<ITEM, unknown> {
    return extractor as DataExtractor<ITEM, unknown, unknown>;
}
